(function (angular) {
  "use strict";

  angular.module("app").filter("capitalise", capitalise);

  /**
   * Capitalizes the first letter of a string
   * @return {Function} - filter
   */
  function capitalise() {
    return function capitaliseFilter(str) {
      if (!str) {
        return "";
      }

      str = str.toString();
      return str.charAt(0).toUpperCase() + str.slice(1);
    };
  }
})(angular);
